export default __webpack_public_path__ + "static/media/ENTREVISTA-EHUD.a882e030.png";